import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

export const StyledSliderWrapper = styled.div<{ $gap: number }>`
	margin: 0 ${(props) => props.$gap && props.$gap}px;
	width: 100%;
	overflow: hidden;
	position: relative;
	padding: 0.313rem 0;
`;

export const StyledTrackWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
`;

export const StyledTrack = styled(motion.div)<{ $gap: number }>`
	min-width: min-content;
	flex-wrap: nowrap;
	cursor: grab;
	display: flex;
	gap: ${(props) => props.$gap && props.$gap}px;
`;

export const StyledSliderButton = styled.button<{ $side: string }>`
	position: absolute;
	top: 0;
	bottom: 0;
	border: none;
	cursor: pointer;
	z-index: 10;
	margin-top: ${({ theme }) => theme.spacing.xxs};

	&:disabled {
		pointer-events: none;
		cursor: default;

		& svg {
			color: ${({ theme }) => theme.colors.textDisabled};
		}
	}

	${({ theme, $side }) => {
		const { colors } = theme;
		return css`
			background-color: ${colors.bgPageBody};
			${$side === 'left' ? 'left: 0' : 'right: 0'}
		`;
	}}
`;

export const StyledMenuCardButton = styled.button`
	width: 100%;
	background-color: transparent;
	border: none;
	max-width: max-content;
`;
